import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  title: any;
  Description1: any;
  Description2: any;
  fontIcon: any;
  btnText: any;
  leadNumber: number;
  hideCloseIcon: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }
  ngOnInit() {
    this.title = this.data.title;
    this.Description1 = this.data.Description1
    this.Description2 = this.data.Description2
    this.leadNumber = this.data.leadNumber
    this.fontIcon = this.data.fontIcon
    this.btnText = this.data.btnText
    this.hideCloseIcon = this.data.hideCloseIcon === true;
  }
  close(): void {
    this.dialogRef.close(true);
  }
}
